import { IAccountHyperMediaRepresentation } from '../../shared/contracts/AccountContract';
import {
    AnswerType,
    INewAnswerRepresentation,
    Point,
    RotationTerm
} from '../../shared/contracts/AnswerContract';

export class NewAnswerModel {
    public quantitative: Point;
    public qualitative: string;
    public account: IAccountHyperMediaRepresentation;
    public rotationTerm: RotationTerm;

    constructor(public id: string, public answerType: AnswerType, quantitative?: Point, rotationTerm?: RotationTerm) {
        if (quantitative) {
            this.quantitative = quantitative;
        }
        if (rotationTerm) {
            this.rotationTerm = rotationTerm;
        }
    }

    mapToNewAnswerRepresentation = (): INewAnswerRepresentation => {
        return {
            accountId: this.account ? this.account.accountId : undefined,
            answerType: this.answerType,
            qualitative: this.qualitative,
            quantitative: this.quantitative,
            rotationTerm: this.rotationTerm
        };
    }
}
